import { render, staticRenderFns } from "./realtimeOrder.vue?vue&type=template&id=4eafcb9c&scoped=true&"
import script from "./realtimeOrder.vue?vue&type=script&lang=ts&"
export * from "./realtimeOrder.vue?vue&type=script&lang=ts&"
import style0 from "./realtimeOrder.vue?vue&type=style&index=0&id=4eafcb9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eafcb9c",
  null
  
)

export default component.exports